import * as React from 'react';
import { SVGProps } from 'react';

const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="M20.973 23.663H18.5v1.997h2.473v-1.997Zm0-7.418H18.5v6.181h2.473v-6.181Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M3.25 33.3v-3.958l13.8-20.686A3.525 3.525 0 0 1 19.838 7.3a3.53 3.53 0 0 1 2.793 1.356l.067.091L36.25 29.692"
    />
    <path fill={props.fill} d="M2.5 29.375v4.92l29.42.025 4.955-4.945H2.5Z" />
  </svg>
);

export default SvgWarning;
